import React, { useContext }  from 'react';
import { ResizeContext } from '../context/ResizeContext';

import NavBig from '../components/Navbar/NavBig';
import NavSmall from '../components/Navbar/NavSmall';
import Cover from '../components/Cover/Cover';
import About from '../components/About/About';
import Specializations from '../components/Specialization/Specializations';
import Projects from '../components/Projects/Projects';
import Contacts from '../components/Contacts/Contacts';
import Footer from '../components/Footer/Footer';

export default function Home() {

  const sizeWindow = useContext(ResizeContext);

  return <>
    {sizeWindow.width > 900 ? <NavBig /> : <NavSmall />}
    <Cover />
    <About />
    <Specializations />
    <div id='Projects'>
      <Projects />
    </div>
    <Contacts />
    <Footer />
  </>
}
